import { Configuration, DefaultApi } from "../../api/kiwi";

export const kiwiApi = (apiKey) =>
  new DefaultApi(
    new Configuration({
      basePath: process.env["REACT_APP_API_URL"],
      apiKey: apiKey,
    })
  );
